import { createSlice } from '@reduxjs/toolkit';
import {
    riego,
} from '../actions/riego';


export const RiegoReducer = createSlice({
    name: 'riego',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(riego.pending, (state) => { state.loading = true })
            .addCase(riego.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(riego.rejected, (state) => { state.loading = false })
    }
})
export default RiegoReducer.reducer;

